import React, { useCallback } from 'react';

import {
  Button,
  FormGroup,
  H1,
  H3,
  Intent,
  TagInput,
  TextArea,
} from '@blueprintjs/core';

import { ItemActions } from './styles';
import { WorkflowStudy } from '../../types';

interface StudyDataProps {
  study: WorkflowStudy;
  onUpdateStudy: (study: WorkflowStudy) => void;
  onSaveStudy: (study: WorkflowStudy) => void;
}

const StudyData = ({ study, onUpdateStudy, onSaveStudy }: StudyDataProps) => {
  const updateTags = useCallback(
    (value: React.ReactNode[]) => {
      const tags = value.map((it) => {
        return String(it);
      });
      onUpdateStudy({
        ...study,
        tags,
      });
    },
    [study, onUpdateStudy],
  );

  const updatePhone = useCallback(
    (value: React.ReactNode[]) => {
      const phone = value.map((it) => {
        return String(it);
      });
      onUpdateStudy({
        ...study,
        phone,
      });
    },
    [study, onUpdateStudy],
  );

  const updateOximeter = useCallback(
    (value: React.ReactNode[]) => {
      const oximeterModel = value.map((it) => {
        return String(it);
      });
      onUpdateStudy({
        ...study,
        oximeterModel,
      });
    },
    [study, onUpdateStudy],
  );

  const updatePreassureGauge = useCallback(
    (value: React.ReactNode[]) => {
      const pressureGaugeModel = value.map((it) => {
        return String(it);
      });
      onUpdateStudy({
        ...study,
        pressureGaugeModel,
      });
    },
    [study, onUpdateStudy],
  );

  const updateGlucoseExtraInfo = useCallback(
    (value: React.ReactNode[]) => {
      const glucoseExtraInfo = value.map((it) => {
        return String(it);
      });
      onUpdateStudy({
        ...study,
        glucoseExtraInfo,
      });
    },
    [study, onUpdateStudy],
  );

  const setNewExtraDescriptionForStudy = useCallback(
    (extraDescription: string) => {
      onUpdateStudy({
        ...study,
        extraDescription,
      });
    },
    [study, onUpdateStudy],
  );

  const saveCurrentStudy = useCallback(() => {
    onSaveStudy(study);
  }, [study, onSaveStudy]);

  return (
    <>
      <H1>Dados do Estudo</H1>
      <H3>Tags</H3>
      <TagInput values={study.tags || []} onChange={updateTags} />
      <H3>Phone</H3>
      <TagInput values={study.phone || []} onChange={updatePhone} />
      <H3>Oxímetro</H3>
      <TagInput values={study.oximeterModel || []} onChange={updateOximeter} />
      <H3>Medidor de Pressão</H3>
      <TagInput
        values={study.pressureGaugeModel || []}
        onChange={updatePreassureGauge}
      />
      <H3>Informação da medição de glicose</H3>
      <TagInput
        values={study.glucoseExtraInfo || []}
        onChange={updateGlucoseExtraInfo}
      />
      <FormGroup
        helperText={'Informações extras do estudo...'}
        intent={Intent.PRIMARY}
        label={'Informações extras do estudo'}
        labelFor="extra-study-input"
      >
        <TextArea
          fill
          placeholder="Informações extras do estudo"
          growVertically={true}
          onChange={(e) => setNewExtraDescriptionForStudy(e.target.value)}
          value={study.extraDescription || ''}
        />
      </FormGroup>
      <ItemActions>
        <Button intent={Intent.PRIMARY} onClick={saveCurrentStudy}>
          Salvar Estudo
        </Button>
      </ItemActions>
    </>
  );
};

export default StudyData;
